import React, { useEffect, useState } from 'react';
import { initAnalytics } from '../utils/analytics';
import {
  CONSENT_UPDATED_EVENT,
  hasStoredConsent,
  saveConsentPreferences
} from '../utils/consent';

function CookieBanner() {
  const [isVisible, setIsVisible] = useState(() => !hasStoredConsent());

  useEffect(() => {
    const handleOpen = () => setIsVisible(true);
    const handleUpdated = () => setIsVisible(false);

    window.addEventListener('cookie-consent:open', handleOpen);
    window.addEventListener(CONSENT_UPDATED_EVENT, handleUpdated);

    return () => {
      window.removeEventListener('cookie-consent:open', handleOpen);
      window.removeEventListener(CONSENT_UPDATED_EVENT, handleUpdated);
    };
  }, []);

  const handleAcceptAll = () => {
    saveConsentPreferences({ analytics: true, advertising: true });
    initAnalytics();
  };

  const handleEssentialOnly = () => {
    saveConsentPreferences({ analytics: false, advertising: false });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <aside className="cookie-banner" aria-live="polite" aria-label="Cookie consent banner">
      <h3>Cookie choices</h3>
      <p>
        We use essential storage to keep the site working. With your permission, we also use analytics cookies to understand
        usage patterns and advertising cookies if ads are enabled in the future.
      </p>
      <p className="cookie-banner-links">
        Read the <a href="/cookie-policy.html" target="_blank" rel="noopener noreferrer">Cookie Policy</a> and
        <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer"> Privacy Policy</a>.
      </p>
      <div className="cookie-banner-actions">
        <button type="button" className="cookie-banner-accept" onClick={handleAcceptAll}>Accept analytics and advertising</button>
        <button type="button" className="cookie-banner-essential" onClick={handleEssentialOnly}>Use essential only</button>
      </div>
      <p className="cookie-banner-note">You can change this later from Cookie Settings in the footer.</p>
    </aside>
  );
}

export default CookieBanner;